import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';
import { TrainerService } from '@thiememeulenhoff/ng-api-gateway';
import {
  TrainerAnswerMethod,
  TrainerCue,
  TrainerSessionProgress,
} from '@thiememeulenhoff/types';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

const ANSWER_METHOD: TrainerAnswerMethod = 'MULTIPLE_CHOICE_4';
const DEFAULT_TIMEZONE = 'Europe/Amsterdam';

type TrainerState = {
  sessionId: string | null;
  cue: TrainerCue | null;
  sessionProgress: TrainerSessionProgress | null;
  isFinished: boolean;
};

const initialState: TrainerState = {
  sessionId: null,
  cue: null,
  sessionProgress: null,
  isFinished: false,
};

export const TrainerStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(),
  withMethods((store, trainerService = inject(TrainerService)) => ({
    async startSession(
      arrangementCode: string,
      wordListId: string,
      context: string,
      timezone = DEFAULT_TIMEZONE,
    ): Promise<void> {
      patchState(store, {
        requestStatus: 'loading',
        sessionId: null,
        cue: null,
        sessionProgress: null,
        isFinished: false,
      });
      try {
        const session = await firstValueFrom(
          trainerService.initializeSession({
            arrangementCode,
            wordListId,
            context,
            answerMethod: ANSWER_METHOD,
            randomOrder: true,
            timezone,
          }),
        );

        patchState(store, {
          requestStatus: 'success',
          sessionId: session.sessionId,
          cue: session.cue,
          sessionProgress: session.sessionProgress,
          isFinished: false,
        });
      } catch (error) {
        patchState(store, {
          requestStatus: toRequestError(error),
        });
        throw error;
      }
    },
  })),
);
